import React, {useRef, useState} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {s_char, s_char_threads} from "../../_signals/s_char";
import {ICharThread} from "../../_interfaces/iCharThread";
import {ThreadCreate} from "../../_api/BEThreads";
import {useSignals} from "@preact/signals-react/runtime";

interface IProp {
    open: boolean,
    isOpen: (open: boolean) => void
}

export default function ThreadsAdd({open, isOpen}: IProp) {
    useSignals()
    const startwith = [100, 200, 300, 500, 800];

    const nameRef = useRef<HTMLInputElement>(null);
    const descRef = useRef<HTMLInputElement>(null);

    const [threadlpstart, setthreadlpstart] = useState(0)


    const savethread = () => {
        let threads = s_char_threads.value;
        const add: ICharThread = {
            cid: s_char.value.id,
            id: v4(),
            name: nameRef.current?.value ?? '',
            descr: descRef.current?.value ?? '',
            lpstart: threadlpstart
        }
        threads.push(add)
        s_char_threads.value = threads
        ThreadCreate(add)

        isOpen(false)
    }

    return <Dialog open={open}>
        <DialogContent>
            <FormControl sx={{m: 1, width: "100%"}}>
                <TextField
                    defaultValue={''}
                    inputRef={nameRef}
                    label={"Name"}
                />
            </FormControl>
            <FormControl sx={{m: 1, width: "100%"}}>
                <InputLabel id="threadstartwith_label">thread startwith</InputLabel>
                <Select
                    labelId="threadstartwith_label"
                    value={threadlpstart || '100'}
                    style={{width: "100%"}}
                >
                    {startwith.map(a => <MenuItem key={v4()}
                                                  value={a}
                                                  onClick={() => setthreadlpstart(a)}>
                        {a}
                    </MenuItem>)}
                </Select>
            </FormControl>
            <FormControl sx={{m: 1, width: "100%"}}>
                <TextField
                    defaultValue={''}
                    style={{width: "100%"}}
                    inputRef={descRef}
                    multiline
                    maxRows={3}
                    label={"DEscr"}
                >
                </TextField>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => savethread()}><CheckIcon/></Button>
            <Button onClick={() => isOpen(false)}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>


}

